// eslint-disable-next-line camelcase
__webpack_public_path__ = window.ioappConfig.resourceBasePath?.frontend || __webpack_public_path__;
